import pageTitle from 'ember-page-title/helpers/page-title';
import PageSetup from 'bcl/components/page-setup';
import { concat } from '@ember/helper';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type SessionService from 'bcl/services/session';
import type Store from '@ember-data/store';
import type RouterService from '@ember/routing/router-service';
import Component from '@glimmer/component';
import OrderForm from 'bcl/components/order-form';
import { saveOrderAndEntries } from 'bcl/templates/auth/orders/new';
import { on } from '@ember/modifier';
import { tracked } from '@glimmer/tracking';
import type OrderModel from 'bcl/models/order';

interface AuthOrdersEditTemplateSignature {
  // The arguments accepted by the component
  Args: {
    model: OrderModel;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class AuthOrdersEditTemplate extends Component<AuthOrdersEditTemplateSignature> {
  @service declare session: SessionService;
  @service declare store: Store;
  @service declare router: RouterService;
  @action
  async save() {
    this.isSaving = true;
    await saveOrderAndEntries(
      this.args.model,
      this.store,
      this.router,
      this.session,
      undefined // location is not needed here
    );
    this.isSaving = false;
  }
  @action cancel() {
    this.args.model.rollbackAttributes();
    this.router.transitionTo('auth.orders');
  }
  @action async confirmDelete() {
    if (confirm('Bestellung wirklich löschen?')) {
      this.args.model.status = 'canceled';
      await this.args.model.save();
      this.router.transitionTo('auth.orders');
    }
  }
  @tracked isSaving = false;

  <template>
    {{pageTitle (concat "Bestellung " @model.id " bearbeiten")}}
    <PageSetup @title={{concat "Bestellung " @model.id " bearbeiten"}}>
      <:header>
        <button
          type="button"
          {{on "click" this.confirmDelete}}
          class="ml-1 rounded px-2 py-1 text-xs font-semibold text-white shadow-sm bg-red-600 hover:bg-red-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >löschen</button>
      </:header>
      <:default>
        <OrderForm
          @model={{@model}}
          @save={{this.save}}
          @cancel={{this.cancel}}
          @isSaving={{this.isSaving}}
        />
      </:default>
    </PageSetup>
  </template>
}
